// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { CommercialAgreementOffer } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Offer';
import {
  ERR_REJECT_COMMERCIAL_AGREEMENT,
  SUC_REJECT_COMMERCIAL_AGREEMENT,
} from '../../../utils/strings';
import { useExerciseSubmission } from '../ledger/useSubmission';

export const useRejectCommercialAgreementOffer = () => {
  const { submit } = useExerciseSubmission(
    CommercialAgreementOffer.CommercialAgreementOffer_Reject,
    SUC_REJECT_COMMERCIAL_AGREEMENT,
    ERR_REJECT_COMMERCIAL_AGREEMENT,
  );
  return submit;
};
